import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import {
  FluentProvider,
  webLightTheme,
  Spinner,
  Toast,
  ToastTitle,
  Toaster,
  useToastController,
  ToastIntent,
  Theme,
} from '@fluentui/react-components';

import Dashboard from '@/pages/Dashboard';
import { useAppStore } from '@/stores/chatbotStore';
import './App.css';

// Alpilink Monetique brand theme — indigo primaire (logo), surfaces claires
const appTheme: Theme = {
  ...webLightTheme,
  colorBrandBackground: '#304494',
  colorBrandBackgroundHover: '#283A7C',
  colorBrandBackgroundPressed: '#1F2D63',
  colorBrandForegroundLink: '#304494',
  colorBrandForegroundLinkHover: '#243676',
  colorNeutralBackground1: '#FFFFFF',
  colorNeutralBackground2: '#F1F2F4',
  colorNeutralBackground3: '#E6E8EC',
  colorNeutralStroke1: '#D7DAE0',
  colorNeutralStroke2: '#E7E9EE',
  fontFamilyBase: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  borderRadiusMedium: '12px',
  borderRadiusLarge: '16px',
  borderRadiusXLarge: '24px',
};

const AppContent: React.FC = () => {
  const { error, chatError, uploadError, clearError } = useAppStore();
  const { dispatchToast } = useToastController('global-toaster');

  // Show toast notifications for errors
  useEffect(() => {
    if (error) {
      dispatchToast(
        <Toast>
          <ToastTitle>Erreur</ToastTitle>
          {error}
        </Toast>,
        { intent: 'error' as ToastIntent, timeout: 5000 }
      );
      clearError();
    }
  }, [error, dispatchToast, clearError]);

  useEffect(() => {
    if (chatError) {
      dispatchToast(
        <Toast>
          <ToastTitle>Erreur de Chat</ToastTitle>
          {chatError}
        </Toast>,
        { intent: 'error' as ToastIntent, timeout: 5000 }
      );
      clearError();
    }
  }, [chatError, dispatchToast, clearError]);

  useEffect(() => {
    if (uploadError) {
      dispatchToast(
        <Toast>
          <ToastTitle>Erreur d'Upload</ToastTitle>
          {uploadError}
        </Toast>,
        { intent: 'error' as ToastIntent, timeout: 5000 }
      );
      clearError();
    }
  }, [uploadError, dispatchToast, clearError]);

  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster toasterId="global-toaster" />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <FluentProvider theme={appTheme}>
      <AppContent />
    </FluentProvider>
  );
};

export default App;